var $win = $(window);
var $doc = $(document);

$doc.ready(function () {
  try {
    if ($win.width() < 768) {
      var $header = $('.header');

      window.addEventListener('scroll', function () {
        if ($win.scrollTop() > 30) {
          $header.addClass('small');
        } else {
          $header.removeClass('small');
        }
      });
    }

    $('.navigation .menu .menu-item-has-children > a').on('click', function (e) {
      if ($win.width() < 1024) {
        e.preventDefault();
      }
    });

    $('.mobile-header .menu > .menu-item-has-children').each(function () {
      $(this).find('> a').append('<span class="toggle-dd"></span>');
    });

    $('.mobile-header .menu > .menu-item-has-children > a').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('show');
    });

    $('.mobile-header').on('click', '.utility .utility__newsletter a', function (e) {
      e.preventDefault();
      $(this).next().toggleClass('show');
    });

    $('#menuButton').on('click', function (e) {
      e.preventDefault();
      $win.scrollTop(0);
      $('body').toggleClass('is-active');
    });

    // listen for resizes from mobile to desktop layouts, and remove is-active class
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768 && document.body.classList.contains('is-active')) {
        document.body.classList.remove('is-active');
      }
    });
  } catch (e) {
    Rollbar.error('mob-navigation', e);
  }
});
